import { Routes, Route, Navigate } from 'react-router-dom';
import { routes } from './routes.jsx';

const Router = () => (
  <Routes>
    {routes.map(({ path, Component }) => (
      <Route key={path} path={path} element={<Component />} />
    ))}
    {/* Redirect all 404's to home */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default Router;
